import { monicaMediaArray } from './monicaMedia'
import { monicaBio } from './monicaBios'

import { rachelReviewerReviewHinge, rossReviewerReviewBumble, joeyReviewerReviewTinder } from './monicaReviewerReviews'
import { rachelReviewerProfile, rossReviewerProfile, joeyReviewerProfile } from './monicaReviewers'

export const rachelProfileReviewHinge = {
  _id: 'rachelProfileReviewHingeId',
  userId: 'monicaUserId',
  userEmail: 'monica@email.com',
  datingProfileId: 'monicaDatingProfileHingeId',
  reviewerProfileId: 'rachelReviewerProfileId',
  reviewerEmail: 'rachel@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: monicaMediaArray[10]._id,
      mediaItemURL: monicaMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[10].type,
      caption: monicaMediaArray[10].captions[0],
      subcaption: monicaMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[4]._id,
      mediaItemURL: monicaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[4].type,
      caption: monicaMediaArray[4].captions[0],
      subcaption: monicaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[0]._id,
      mediaItemURL: monicaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[0].type,
      caption: monicaMediaArray[0].captions[0],
      subcaption: monicaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[11]._id,
      mediaItemURL: monicaMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[11].type,
      caption: monicaMediaArray[11].captions[0],
      subcaption: monicaMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[7]._id,
      mediaItemURL: monicaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[7].type,
      caption: monicaMediaArray[7].captions[0],
      subcaption: monicaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[5]._id,
      mediaItemURL: monicaMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[5].type,
      caption: monicaMediaArray[5].captions[0],
      subcaption: monicaMediaArray[5].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You're a stunner'! Love the hair, the expression, and the outfit!`,
      verdict: 'Very',
    },
    {
      feedback: `Amazing dress! Again, you look great! Love the expression`,
      verdict: 'Very',
    },
    {
      feedback: `Great smile! Nice candid moment!`,
      verdict: 'Yes',
    },
    {
      feedback: `It's good to show off your friends! Especially when you look so good! Social proof!`,
      verdict: 'Yes',
    },
    {
      feedback: `This is a funny change of pace. You look good, but perhaps it shows the true Monica a bit too soon. Wait until the third date for this one`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Great smile! Love the laidback outfit too`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: monicaBio._id,
    vitalInfo: { ...monicaBio.vitalInfo },
    prompts: [
      { ...monicaBio.prompts[0] },
      { ...monicaBio.prompts[1] },
      { ...monicaBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Professional chef? Jackpot!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, but a bit too true. Maybe hide your intensity for now`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Love the lightness here`,
        verdict: 'Yes', 
      },
      {
        feedback: `A good way to start a conversation about food!`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Monica is very pretty and well-directed but perhaps a bit intense.`,
    good: `Your smile is great, and so are the candid moments and your outfits`,
    notGood: `References to your intensity might turn some people off`,
    verdict: `Overall you have a great profile already! Just clean up the intensity references and you'll be matching with everyone`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...rachelReviewerReviewHinge },
  reviewerProfile: { ...rachelReviewerProfile },
  bioItems: { ...monicaBio },
  mediaItems: [ ...monicaMediaArray ],
}

export const rossProfileReviewBumble = {
  _id: 'rossProfileReviewBumbleId',
  userId: 'monicaUserId',
  userEmail: 'monica@email.com',
  datingProfileId: 'monicaDatingProfileBumbleId',
  reviewerProfileId: 'rossReviewerProfileId',
  reviewerEmail: 'ross@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: monicaMediaArray[10]._id,
      mediaItemURL: monicaMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[10].type,
      caption: monicaMediaArray[10].captions[0],
      subcaption: monicaMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[4]._id,
      mediaItemURL: monicaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[4].type,
      caption: monicaMediaArray[4].captions[0],
      subcaption: monicaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[0]._id,
      mediaItemURL: monicaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[0].type,
      caption: monicaMediaArray[0].captions[0],
      subcaption: monicaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[11]._id,
      mediaItemURL: monicaMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[11].type,
      caption: monicaMediaArray[11].captions[0],
      subcaption: monicaMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[7]._id,
      mediaItemURL: monicaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[7].type,
      caption: monicaMediaArray[7].captions[0],
      subcaption: monicaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[5]._id,
      mediaItemURL: monicaMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[5].type,
      caption: monicaMediaArray[5].captions[0],
      subcaption: monicaMediaArray[5].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You're a stunner'! Love the hair, the expression, and the outfit!`,
      verdict: 'Very',
    },
    {
      feedback: `Amazing dress! Again, you look great! Love the expression`,
      verdict: 'Very',
    },
    {
      feedback: `Great smile! Nice candid moment!`,
      verdict: 'Yes',
    },
    {
      feedback: `It's good to show off your friends! Especially when you look so good! Social proof!`,
      verdict: 'Yes',
    },
    {
      feedback: `This is a funny change of pace. You look good, but perhaps it shows the true Monica a bit too soon. Wait until the third date for this one`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Great smile! Love the laidback outfit too`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: monicaBio._id,
    vitalInfo: { ...monicaBio.vitalInfo },
    prompts: [
      { ...monicaBio.prompts[0] },
      { ...monicaBio.prompts[1] },
      { ...monicaBio.prompts[2] }
    ],
    aboutMe: monicaBio.aboutMe[0],
    hobbies: [monicaBio.hobbies[0], monicaBio.hobbies[1], monicaBio.hobbies[2], monicaBio.hobbies[3], monicaBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Professional chef? Jackpot!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Kind of funny... but not really. Scrub the intensity references',
      verdict: 'No', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, but a bit too true. Maybe hide your intensity for now`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Love the lightness here`,
        verdict: 'Yes', 
      },
      {
        feedback: `A good way to start a conversation about food!`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Monica is very pretty and well-directed but perhaps a bit intense.`,
    good: `Your smile is great, and so are the candid moments and your outfits`,
    notGood: `References to your intensity might turn some people off`,
    verdict: `Overall you have a great profile already! Just clean up the intensity references and you'll be matching with everyone`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...rossReviewerReviewBumble },
  reviewerProfile: { ...rossReviewerProfile },
  bioItems: { ...monicaBio },
  mediaItems: [ ...monicaMediaArray ],
}

export const joeyProfileReviewTinder = {
  _id: 'joeyProfileReviewTinderId',
  userId: 'monicaUserId',
  userEmail: 'monica@email.com',
  datingProfileId: 'monicaDatingProfileTinderId',
  reviewerProfileId: 'joeyReviewerProfileId',
  reviewerEmail: 'joey@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: monicaMediaArray[10]._id,
      mediaItemURL: monicaMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[10].type,
      caption: monicaMediaArray[10].captions[0],
      subcaption: monicaMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[4]._id,
      mediaItemURL: monicaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[4].type,
      caption: monicaMediaArray[4].captions[0],
      subcaption: monicaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[0]._id,
      mediaItemURL: monicaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[0].type,
      caption: monicaMediaArray[0].captions[0],
      subcaption: monicaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[11]._id,
      mediaItemURL: monicaMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[11].type,
      caption: monicaMediaArray[11].captions[0],
      subcaption: monicaMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[7]._id,
      mediaItemURL: monicaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[7].type,
      caption: monicaMediaArray[7].captions[0],
      subcaption: monicaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: monicaMediaArray[5]._id,
      mediaItemURL: monicaMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: monicaMediaArray[5].type,
      caption: monicaMediaArray[5].captions[0],
      subcaption: monicaMediaArray[5].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You're a stunner'! Love the hair, the expression, and the outfit!`,
      verdict: 'Very',
    },
    {
      feedback: `Amazing dress! Again, you look great! Love the expression`,
      verdict: 'Very',
    },
    {
      feedback: `Great smile! Nice candid moment!`,
      verdict: 'Yes',
    },
    {
      feedback: `It's good to show off your friends! Especially when you look so good! Social proof!`,
      verdict: 'Yes',
    },
    {
      feedback: `This is a funny change of pace. You look good, but perhaps it shows the true Monica a bit too soon. Wait until the third date for this one`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Great smile! Love the laidback outfit too`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: monicaBio._id,
    vitalInfo: { ...monicaBio.vitalInfo },
    prompts: [
      { ...monicaBio.prompts[0] },
      { ...monicaBio.prompts[1] },
      { ...monicaBio.prompts[2] }
    ],
    aboutMe: monicaBio.aboutMe[0],
    hobbies: [monicaBio.hobbies[0], monicaBio.hobbies[1], monicaBio.hobbies[2], monicaBio.hobbies[3], monicaBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Professional chef? Jackpot!`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Kind of funny... but not really. Scrub the intensity references',
      verdict: 'No', 
    },
    promptsFeedback: [
      {
        feedback: `Funny, but a bit too true. Maybe hide your intensity for now`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Love the lightness here`,
        verdict: 'Yes', 
      },
      {
        feedback: `A good way to start a conversation about food!`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Monica is very pretty and well-directed but perhaps a bit intense.`,
    good: `Your smile is great, and so are the candid moments and your outfits`,
    notGood: `References to your intensity might turn some people off`,
    verdict: `Overall you have a great profile already! Just clean up the intensity references and you'll be matching with everyone`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...joeyReviewerReviewTinder },
  reviewerProfile: { ...joeyReviewerProfile },
  bioItems: { ...monicaBio },
  mediaItems: [ ...monicaMediaArray ],
}